export default "__VITE_ASSET__DWIwTgQt__"